import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { AdvantageBox, type AdvantageBoxProps } from './AdvantageBox';
import { mergeClasses } from '@/utils/style';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
interface Props {
  items: AdvantageBoxProps[];
  className?: string;
  variant?: 'light' | 'dark';
}
export function AdvantageBoxes(props) {
  const $ = _c(25);
  const {
    className,
    items,
    variant: t0
  } = props;
  const variant = t0 === undefined ? "light" : t0;
  if (!items.length) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = mergeClasses("md:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className || $[3] !== variant) {
    t2 = mergeClasses(className, variant);
    $[2] = className;
    $[3] = variant;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [Pagination];
    t4 = {
      clickable: true
    };
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  let t5;
  if ($[7] !== items) {
    t5 = items.map(_temp);
    $[7] = items;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t5) {
    t6 = <Swiper className={t2} wrapperClass="pb-16" modules={t3} pagination={t4} centeredSlides={true} spaceBetween={16} slidesPerView="auto" initialSlide={1} loop={true}>{t5}</Swiper>;
    $[9] = t2;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t6) {
    t7 = <section className={t1}>{t6}</section>;
    $[12] = t1;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== className) {
    t8 = mergeClasses("mx-auto hidden max-w-192 grid-cols-2 grid-rows-2 gap-4 px-2 pb-4 md:grid", "lg:gap-8", className);
    $[15] = className;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== items) {
    t9 = items.map(_temp2);
    $[17] = items;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t8 || $[20] !== t9) {
    t10 = <section className={t8}>{t9}</section>;
    $[19] = t8;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t7) {
    t11 = <div className="md:px-4">{t7}{t10}</div>;
    $[22] = t10;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}
function _temp2(item_0, index_0) {
  return <AdvantageBox key={index_0} {...item_0} />;
}
function _temp(item, index) {
  return <SwiperSlide key={index} className="xs:w-[21.25rem]! flex h-auto! w-[18.75rem]! items-center justify-center"><AdvantageBox {...item} /></SwiperSlide>;
}